module.exports = new __parcel__URL__("Warriorskill_38.240c4dc3.png").toString();